import React from "react"
import ResponsiveMenu from "react-responsive-navbar"

// import { Container, Row, Col } from "react-grid-system"

import "../style.css"

import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai"

const TopNav = () => {
  return (
    <div className="top-nav">
      {/* <div className="nav">
        <input type="checkbox" id="nav-check" />
        <div className="nav-header">
          <div className="nav-title">
            {" "}
            <img
              src={require("../assets/images/imagehivebeta.png")}
              alt=""
              style={{ width: "198px" }}
            />
          </div>
        </div>
        <div className="nav-btn">
          <label htmlFor="nav-check">
            <span />
            <span />
            <span />
          </label>
        </div>
        <div className="nav-links">
          {/* <a
            href="https://dashboard.flutterwave.com/donate/ewsb9x007xlh"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sponsor
          </a>
          <a
            href="http://twitter.com/imagehive_"
            target="_blank"
            rel="noopener noreferrer"
          >
            Twitter
          </a>
          <a
            href="https://youtu.be/9XjG-vmMA1Y"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button class="hero-btn2">Watch a Tutorial</button>
          </a>
        </div>
      </div> */}

      <div className="top-nav__logo">
        <img src={require("../assets/images/imagehivebeta.png")} alt="" />
      </div>
      <div className="top-nav__nav-container">
        <ResponsiveMenu
          menuOpenButton={
            <div className="top-nav__button">
              <AiOutlineMenu />
            </div>
          }
          menuCloseButton={
            <div className="top-nav__button">
              <AiOutlineClose />
            </div>
          }
          changeMenuOn="576px"
          menu={
            <div className="top-nav__nav">
              <div className="top-nav__nav--item">
                <a
                  href="http://twitter.com/developerayo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div className="top-nav__nav--item">
                <a
                  href="https://www.producthunt.com/posts/imagehive?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-imagehive"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="hero-btn2">Upvote on Producthunt</button>
                </a>
              </div>
            </div>
          }
        />
      </div>
    </div>
  )
}

export default TopNav
